export default "__VITE_ASSET__nLGcy1g___"